import { StyledSkeleton } from '@/components/table/TableView';

import { ReactNode } from 'react';
import MuiTable from '@mui/material/Table';
import MuiTableBody from '@mui/material/TableBody';
import MuiTableCell from '@mui/material/TableCell';
import MuiTableContainer from '@mui/material/TableContainer';
import MuiTableRow from '@mui/material/TableRow';

export const LoadingTable = (): ReactNode => {
  return (
    <MuiTableContainer sx={{ padding: '24px' }}>
      <MuiTable size="small">
        <MuiTableBody>
          <MuiTableRow>
            <MuiTableCell sx={{ width: '33px' }} />
            <MuiTableCell>
              <StyledSkeleton />
            </MuiTableCell>
            <MuiTableCell>
              <StyledSkeleton />
            </MuiTableCell>
            <MuiTableCell>
              <StyledSkeleton />
            </MuiTableCell>
            <MuiTableCell>
              <StyledSkeleton />
            </MuiTableCell>
            <MuiTableCell sx={{ width: '33px' }} />
          </MuiTableRow>
          <MuiTableRow>
            <MuiTableCell sx={{ width: '33px' }} />
            <MuiTableCell>
              <StyledSkeleton />
            </MuiTableCell>
            <MuiTableCell>
              <StyledSkeleton />
            </MuiTableCell>
            <MuiTableCell>
              <StyledSkeleton />
            </MuiTableCell>
            <MuiTableCell>
              <StyledSkeleton />
            </MuiTableCell>
            <MuiTableCell sx={{ width: '33px' }} />
          </MuiTableRow>
        </MuiTableBody>
      </MuiTable>
    </MuiTableContainer>
  );
};
